import algoliasearch from 'algoliasearch';
import Request from '../common/api/request';
import ServiceResultFactory from '../common/api/ServiceResultFactory';
import logger from '../logger';

const getApiKey = (baseApiUrl, eventEditionId, interfaceLocale, isNewIndex = false) => (
  Request.get(`${baseApiUrl}v1/event-editions/${eventEditionId}/algolia/token?isNewIndex=${isNewIndex}`)
    .then((response) => {
      if (response.body && response.body.errors && response.body.errors.length) {
        throw response.body;
      }
      return ServiceResultFactory.fromSuccess(response.body);
    })
    .catch((response) => {
      const errors = response.errors || ((response.body && response.body.errors) || []);
      const errorResponse = ServiceResultFactory.error.constructLocalizedErrorMessage(
        interfaceLocale,
        errors.map((error) => error.code || error.extensions.code)
      );
      logger.logWarn(`Error while getting Algolia Api key - ${JSON.stringify(response)}`, errorResponse, baseApiUrl);
      throw errorResponse;
    }));

const getAlgoliaDataById = (appId, apiKey, indexName, id) => {
  const client = algoliasearch(appId, apiKey, { protocol: 'https:' });
  const index = client.initIndex(indexName);
  return index.getObject(id);
};

export default { getApiKey, getAlgoliaDataById };
